export default __webpack_public_path__ + "static/media/error_icon.8e673960.png";